import { FormControl, FormItem, FormLabel } from '@/components/ui/Form/Form';
import { RadioGroupItem } from '@/components/ui/RadioGroup/RadioGroup';

interface SessionDetailsRowProps {
  value: string;
  label: string;
  hideRadio?: boolean;
}

export const SessionDetailsRow = ({ value, label, hideRadio }: SessionDetailsRowProps) => {
  return (
    <FormItem className='bg-fill-background-light mb-1 flex flex-row items-center justify-between rounded-lg px-5 py-3'>
      <FormLabel className='text-text-default-primary flex-1 font-semibold'>{label}</FormLabel>
      <FormControl>{!hideRadio && <RadioGroupItem value={value} />}</FormControl>
    </FormItem>
  );
};
